import {
  IParticleShape,
  ParticleShapeData,
} from "./VolumetricParticles.interface";

const ethVertices = [
  [217.32652187347412, 441.30148883323545, -0.26466287576023295],
  [0, 312.469482421875, -0.0000509077399490935],
  [0, 250.97836683198673, 99.3896969549041],
  [217.32652187347412, 441.30148883323545, -0.26466287576023295],
  [0, 250.97836683198673, 99.3896969549041],
  [217.32652187347412, 441.3014920126563, 19.250483439337575],
  [217.32652187347412, 441.3014920126563, 19.250483439337575],
  [0, 250.97836683198673, 99.3896969549041],
  [-0.000020661194355398038, 138.93680898351127, 19.999977662344627],
  [-0.000020661194355398038, 138.93680898351127, 19.999977662344627],
  [0, 250.97836683198673, 99.3896969549041],
  [-217.32652187347412, 441.3014922568567, 20.749374852549398],
  [0, 874.7024568716948, 19.999857790906383],
  [0, 615.8195243856396, 138.15798263230533],
  [220.60003280639648, 477.99573258272466, 19.250477461087023],
  [220.60003280639648, 477.99573258272466, 19.250477461087023],
  [0, 615.8195243856396, 138.15798263230533],
  [-0.000020661194355398038, 369.945482901762, 27.390145588369748],
  [-0.000020661194355398038, 369.945482901762, 27.390145588369748],
  [0, 615.8195243856396, 138.15798263230533],
  [-220.60003280639648, 477.99573282692484, 20.749367384182726],
  [-220.60003280639648, 477.99573282692484, 20.749367384182726],
  [0, 615.8195243856396, 138.15798263230533],
  [0, 874.7024568716948, 19.999857790906383],
  [217.32652187347412, 441.30148883323545, -0.26466287576023295],
  [217.32652187347412, 441.3014856538143, -19.779810680974162],
  [0, 250.9783344466998, -99.38977873403023],
  [217.32652187347412, 441.30148883323545, -0.26466287576023295],
  [0, 250.9783344466998, -99.38977873403023],
  [0, 312.469482421875, -0.0000509077399490935],
  [217.32652187347412, 441.3014856538143, -19.779810680974162],
  [-0.000020661194355398038, 138.9368025025692, -19.779761419514962],
  [0, 250.9783344466998, -99.38977873403023],
  [220.60003280639648, 477.99573258272466, 19.250477461087023],
  [220.60003280639648, 477.9957263494801, -19.008905084861006],
  [0, 874.7024503907528, -19.779881290953206],
  [220.60003280639648, 477.99573258272466, 19.250477461087023],
  [0, 874.7024503907528, -19.779881290953206],
  [0, 874.7024568716948, 19.999857790906383],
  [-0.000020661194355398038, 138.9368025025692, -19.779761419514962],
  [-217.32652187347412, 441.30148540261945, -21.32163382970158],
  [0, 250.9783344466998, -99.38977873403023],
  [0, 250.97836683198673, 99.3896969549041],
  [0, 312.469482421875, -0.0000509077399490935],
  [-217.32652187347412, 441.3014888297381, -0.2861294885760899],
  [0, 250.97836683198673, 99.3896969549041],
  [-217.32652187347412, 441.3014888297381, -0.2861294885760899],
  [-217.32652187347412, 441.3014922568567, 20.749374852549398],
  [0, 874.7024503907528, -19.779881290953206],
  [220.60003280639648, 477.9957263494801, -19.008905084861006],
  [0, 615.8194793680225, -138.15818329176693],
  [220.60003280639648, 477.9957263494801, -19.008905084861006],
  [-0.000020661194355398038, 369.9454752168026, -19.779799055604556],
  [0, 615.8194793680225, -138.15818329176693],
  [0, 874.7024503907528, -19.779881290953206],
  [-220.60003280639648, 477.9957260982852, -20.550728233588423],
  [-220.60003280639648, 477.99573282692484, 20.749367384182726],
  [0, 874.7024503907528, -19.779881290953206],
  [-220.60003280639648, 477.99573282692484, 20.749367384182726],
  [0, 874.7024568716948, 19.999857790906383],
  [-0.000020661194355398038, 369.9454752168026, -19.779799055604556],
  [-220.60003280639648, 477.9957260982852, -20.550728233588423],
  [0, 615.8194793680225, -138.15818329176693],
  [-220.60003280639648, 477.9957260982852, -20.550728233588423],
  [0, 874.7024503907528, -19.779881290953206],
  [0, 615.8194793680225, -138.15818329176693],
  [-220.60003280639648, 477.9957260982852, -20.550728233588423],
  [-0.000020661194355398038, 369.9454752168026, -19.779799055604556],
  [-0.000020661194355398038, 369.945482901762, 27.390145588369748],
  [-220.60003280639648, 477.9957260982852, -20.550728233588423],
  [-0.000020661194355398038, 369.945482901762, 27.390145588369748],
  [-220.60003280639648, 477.99573282692484, 20.749367384182726],
  [-0.000020661194355398038, 369.945482901762, 27.390145588369748],
  [-0.000020661194355398038, 369.9454752168026, -19.779799055604556],
  [220.60003280639648, 477.9957263494801, -19.008905084861006],
  [-0.000020661194355398038, 369.945482901762, 27.390145588369748],
  [220.60003280639648, 477.9957263494801, -19.008905084861006],
  [220.60003280639648, 477.99573258272466, 19.250477461087023],
  [-0.000020661194355398038, 138.93680898351127, 19.999977662344627],
  [-0.000020661194355398038, 138.9368025025692, -19.779761419514962],
  [217.32652187347412, 441.3014856538143, -19.779810680974162],
  [217.32652187347412, 441.30148883323545, -0.26466287576023295],
  [-0.000020661194355398038, 138.93680898351127, 19.999977662344627],
  [217.32652187347412, 441.3014856538143, -19.779810680974162],
  [-0.000020661194355398038, 138.93680898351127, 19.999977662344627],
  [217.32652187347412, 441.30148883323545, -0.26466287576023295],
  [217.32652187347412, 441.3014920126563, 19.250483439337575],
  [-217.32652187347412, 441.3014888297381, -0.2861294885760899],
  [-217.32652187347412, 441.30148540261945, -21.32163382970158],
  [-0.000020661194355398038, 138.9368025025692, -19.779761419514962],
  [-0.000020661194355398038, 138.93680898351127, 19.999977662344627],
  [-217.32652187347412, 441.3014888297381, -0.2861294885760899],
  [-0.000020661194355398038, 138.9368025025692, -19.779761419514962],
  [-217.32652187347412, 441.3014888297381, -0.2861294885760899],
  [-0.000020661194355398038, 138.93680898351127, 19.999977662344627],
  [-217.32652187347412, 441.3014922568567, 20.749374852549398],
  [0, 312.469482421875, -0.0000509077399490935],
  [0, 250.9783344466998, -99.38977873403023],
  [-217.32652187347412, 441.30148540261945, -21.32163382970158],
  [0, 312.469482421875, -0.0000509077399490935],
  [-217.32652187347412, 441.30148540261945, -21.32163382970158],
  [-217.32652187347412, 441.3014888297381, -0.2861294885760899],
];
const ethFaces = [
  [0, 1, 2],
  [3, 4, 5],
  [6, 7, 8],
  [9, 10, 11],
  [12, 13, 14],
  [15, 16, 17],
  [18, 19, 20],
  [21, 22, 23],
  [24, 25, 26],
  [27, 28, 29],
  [30, 31, 32],
  [33, 34, 35],
  [36, 37, 38],
  [39, 40, 41],
  [42, 43, 44],
  [45, 46, 47],
  [48, 49, 50],
  [51, 52, 53],
  [54, 55, 56],
  [57, 58, 59],
  [60, 61, 62],
  [63, 64, 65],
  [66, 67, 68],
  [69, 70, 71],
  [72, 73, 74],
  [75, 76, 77],
  [78, 79, 80],
  [81, 82, 83],
  [84, 85, 86],
  [87, 88, 89],
  [90, 91, 92],
  [93, 94, 95],
  [96, 97, 98],
  [99, 100, 101],
];

export class EthParticles implements IParticleShape {
  generate(count: number, size: number): ParticleShapeData {
    const positions = new Float32Array(count * 3);
    const types = new Float32Array(count);

    // Compute bounding box of the raw OBJ data
    let minX = Infinity,
      minY = Infinity,
      minZ = Infinity;
    let maxX = -Infinity,
      maxY = -Infinity,
      maxZ = -Infinity;

    for (const v of ethVertices) {
      minX = Math.min(minX, v[0] || 0);
      minY = Math.min(minY, v[1] || 0);
      minZ = Math.min(minZ, v[2] || 0);
      maxX = Math.max(maxX, v[0] || 0);
      maxY = Math.max(maxY, v[1] || 0);
      maxZ = Math.max(maxZ, v[2] || 0);
    }

    const centerX = (minX + maxX) / 2;
    const centerY = (minY + maxY) / 2;
    const centerZ = (minZ + maxZ) / 2;

    const sizeY = maxY - minY;
    // Scale to match requested size (approx 1.6 ratio)
    const scale = size / sizeY;

    for (let i = 0; i < count; i++) {
      // Determine if particle is inside (Gold) or surface (Blue)
      // 30% inside, 70% surface
      const isInside = Math.random() < 0.3;
      types[i] = isInside ? 1.0 : 0.0;

      // Pick a random face
      const faceIdx = Math.floor(Math.random() * ethFaces.length);
      const face = ethFaces[faceIdx];
      if (!face) continue;

      // Get vertices for the face
      const idxA = face[0];
      const idxB = face[1];
      const idxC = face[2];

      if (idxA === undefined || idxB === undefined || idxC === undefined)
        continue;

      const vA = ethVertices[idxA];
      const vB = ethVertices[idxB];
      const vC = ethVertices[idxC];

      if (!vA || !vB || !vC) continue;

      // Random barycentric coords
      let r1 = Math.random();
      let r2 = Math.random();
      if (r1 + r2 > 1) {
        r1 = 1 - r1;
        r2 = 1 - r2;
      }
      const r3 = 1 - r1 - r2;

      // Interpolate position
      let x = (vA[0] || 0) * r1 + (vB[0] || 0) * r2 + (vC[0] || 0) * r3;
      let y = (vA[1] || 0) * r1 + (vB[1] || 0) * r2 + (vC[1] || 0) * r3;
      let z = (vA[2] || 0) * r1 + (vB[2] || 0) * r2 + (vC[2] || 0) * r3;

      // Center the model
      x -= centerX;
      y -= centerY;
      z -= centerZ;

      // Apply scale
      x *= scale;
      y *= scale;
      z *= scale;

      if (isInside) {
        // Move towards center, shifted higher to the thickest point
        // Limit scaleFactor to 0.7 to keep particles deep inside (prevent bleeding)
        const targetY = size * 0.25;
        const scaleFactor = Math.random() * 0.7;
        x *= scaleFactor;
        y = targetY + (y - targetY) * scaleFactor;
        z *= scaleFactor;
      }

      positions[i * 3] = x;
      positions[i * 3 + 1] = y;
      positions[i * 3 + 2] = z;
    }

    return { positions, extraAttributes: { types } };
  }
}
